import type { Aggregation, JobEntity } from '@/types/job.types';

/**
 * Profile types — mirrors Flutter CandidateDetails + Profile models.
 *
 * Flutter source:
 *   lib/infrastructure/models/candidate/candidate_details.dart
 *   lib/infrastructure/models/view_jobs/view_jobs_model.dart
 *   lib/infrastructure/models/basic_information/basic_information_modal.dart
 */

/* ── CandidateDetails — mirrors Flutter CandidateDetails ── */
export interface CandidateDetails {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayId?: string;
  primaryEmailId?: string;
  secondaryEmailId?: string;
  primaryContactNumber?: string;
  secondaryContactNumber?: string;
  linkedInUrl?: string;
  candidateUrl?: string;
  createdBy?: string;
  updatedBy?: string;
  createdOn?: number;
  updatedOn?: number;
  workspaceId?: string;
  currentRole?: string;
  currentLocation?: string;
  experienceInMonths?: number;
  resumeUpdateOn?: number;
  secondaryContactNumberCountryCode?: string;
  primaryContactNumberCountryCode?: string;
  isMfaEnabled?: boolean;
  [key: string]: unknown;
}

/* ── ViewJobsData — mirrors Flutter ViewJobsData (same shape as a search Entities item) ── */
export type ViewJobsData = JobEntity;

/* ── ApplicationData — mirrors Flutter ApplicationData for applied jobs ── */
export interface ApplicationData {
  id?: string;
  displayId?: string;
  jobTitle?: string;
  jobDisplayId?: string;
  appliedStatus?: string;
  createdOn?: number;
  updatedOn?: number;
  [key: string]: unknown;
}

/* ── RecommendedJobsResponse — mirrors Flutter SearchWithAggrModel (recommendations) ── */
export interface RecommendedJobsResponse {
  entities: JobEntity[];
  total?: number;
  aggregations?: Aggregation[];
}

/* ── View Jobs sub-tabs — mirrors Flutter WebViewJobs tabs ── */
export enum ViewJobsTab {
  APPLIED = 0,
  INVITED = 1,
  RECOMMENDED = 2,
  SAVED = 3,
}

/* ── Applied jobs filter — mirrors Flutter appliedJobsFilter ── */
export type AppliedJobsFilter = 'All' | 'Pending' | 'Applied';
